import Vue from "vue";

export default {
  namespaced: true,
  state: {
    auth: false,
    email: ''
  },
  mutations: {
    'CHANGE_AUTH': (state, auth) => state.auth = auth,
    'CHANGE_EMAIL': (state, email) => state.email = email
  },
  actions: {
    'AUTH': async (state, params) => {
      console.log(params);
      return await Vue.http.post(`${process.env.VUE_APP_API_URL}users/login`, params)
        .then(
          res => {
            localStorage.setItem('token', res.body.user.token);
            localStorage.setItem('email', res.body.user.email);
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    }
  }
}